module.exports = __webpack_public_path__ + "static/img/iiw.3830a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/work/iiw.png
// module id = 4okQ
// module chunks = 0